import React from "react"
import types from "prop-types"
import { questionShape } from "utils/propTypeShapes"
import { PrimaryButton, TertiaryButton } from "shared/buttons"
import Modal, { ModalHeader } from "shared/Modal"
import EDIT_SUBMISSION_MODAL_STYLE from "./editSubmissionModalStyle"
import LostAnswersOverview from "./LostAnswersOverview"

const EditSubmissionLostAnswersModal = ({
  close, isOpen, onContinue, questions,
}) => (
  <Modal isOpen={isOpen} style={EDIT_SUBMISSION_MODAL_STYLE}>
    <ModalHeader
      closeModal={close}
      heading="Change Answers"
    />
    <LostAnswersOverview className="mb-8" questions={questions} />
    <div className="flex flex-col items-center">
      <div className="flex">
        <TertiaryButton className="mr-4" onClick={close} text="Cancel" />
        <PrimaryButton onClick={onContinue} text="Continue" />
      </div>
    </div>
  </Modal>
)

EditSubmissionLostAnswersModal.propTypes = {
  close: types.func.isRequired,
  isOpen: types.bool.isRequired,
  onContinue: types.func.isRequired,
  questions: types.arrayOf(questionShape).isRequired,
}

export default EditSubmissionLostAnswersModal
